import axios, { type GenericAbortSignal } from "axios";

import type { IPaginationResponse } from "../common/types";
import type {
  IAddLenderInternalCommentInput,
  IAssignLenderApplicationInput,
  ICreateTestLenderApplicationInput,
  ICreateTestLenderApplicationResponse,
  ILenderApplicationExtended,
  ILenderApplicationMinimal,
  IListLenderApplicationParams,
  IRejectLenderApplicationInput,
  ISearchedLenderApplication,
} from "./types/lender-application";

export const fetchListLenderApplications = async (
  lenderCompanyId: number,
  params: IListLenderApplicationParams,
  signal?: GenericAbortSignal,
) => {
  const response = await axios.get<
    IPaginationResponse<ILenderApplicationMinimal>
  >(`/lender/api/v1/lender-companies/${lenderCompanyId}/lender-applications`, {
    params,
    signal,
  });

  return response.data;
};

export const fetchOneLenderApplication = async (
  lenderCompanyId: number,
  lenderApplicationId: number,
) => {
  const response = await axios.get<ILenderApplicationExtended>(
    `/lender/api/v1/lender-companies/${lenderCompanyId}/lender-applications/${lenderApplicationId}`,
  );

  return response.data;
};

export const searchLenderApplications = async (
  lenderCompanyId: number,
  search: string,
) => {
  const response = await axios.get<{
    items: ISearchedLenderApplication[];
    count: number;
  }>(
    `/lender/api/v1/lender-companies/${lenderCompanyId}/search-lender-applications`,
    { params: { search } },
  );

  return response.data;
};

export const rejectLenderApplication = async (
  lenderCompanyId: number,
  lenderApplicationId: number,
  input: IRejectLenderApplicationInput,
) => {
  const response = await axios.post<ILenderApplicationExtended>(
    `/lender/api/v1/lender-companies/${lenderCompanyId}/lender-applications/${lenderApplicationId}/reject`,
    input,
  );

  return response.data;
};

export const addInternalComment = async (
  lenderCompanyId: number,
  lenderApplicationId: number,
  input: IAddLenderInternalCommentInput,
) => {
  const response = await axios.post<ILenderApplicationExtended>(
    `/lender/api/v1/lender-companies/${lenderCompanyId}/lender-applications/${lenderApplicationId}/internal-comments`,
    input,
  );

  return response.data;
};

export const reopenApplication = async (
  lenderCompanyId: number,
  lenderApplicationId: number,
) => {
  const response = await axios.post<ILenderApplicationExtended>(
    `/lender/api/v1/lender-companies/${lenderCompanyId}/lender-applications/${lenderApplicationId}/reopen`,
  );

  return response.data;
};

export const createTestLenderApplication = async (
  lenderCompanyId: number,
  input?: ICreateTestLenderApplicationInput,
) => {
  const response = await axios.post<ICreateTestLenderApplicationResponse>(
    `/lender/api/v1/lender-companies/${lenderCompanyId}/create-and-open-test-loan-application-for-lender`,
    input,
  );

  return response.data;
};

export const assignLenderApplication = async (
  lenderCompanyId: number,
  lenderApplicationId: number,
  input: IAssignLenderApplicationInput,
) => {
  const response = await axios.post<ILenderApplicationExtended>(
    `/lender/api/v1/lender-companies/${lenderCompanyId}/lender-applications/${lenderApplicationId}/assign-user`,
    input,
  );

  return response.data;
};
